import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDropdownModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputModule } from 'ng-otp-input';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ToastrModule } from 'ngx-toastr';
import { UserGuideComponent } from '../Components/user-guide/user-guide.component';
import { VaultAuthenticationComponent } from '../User/Components/files/vault-authentication/vault-authentication.component';
import { WeatherPopupComponent } from '../User/Components/files/weather-popup/weather-popup.component';
import { SearchPipe } from '../utils/search.pipe';
import { DisableButtonDuringAjax } from './Directives/DisableButtonDuringAjax';
import {
  CustomDateAdapter,
  CustomDateParserFormatter,
} from './Directives/datepicker-popup';
import { PhoneMaskDirective } from './Directives/phone-mask';
import { SanitizeHtmlPipe } from './Directives/sanitizeHtml';
import { ConfirmDailogue } from './confirm-dailogue/confirmDailogue.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { UserPendingInviteComponent } from '../Components/user-pending-invite/user-pending-invite.component';
import { NgFileUploadDirective } from './Directives/file-size';
import { DebounceDirective } from './Directives/debounce.directive';
import { FileDragNDropDirective } from '../User/Directives/file-drag-n-drop.directive';
import { SafePipe } from '../utils/Safe.pipe';
import { AppDatePipe } from '../Service/app-date.pipe';

@NgModule({
  declarations: [
    VaultAuthenticationComponent,
    PhoneMaskDirective,
    DisableButtonDuringAjax,
    SanitizeHtmlPipe,
    SearchPipe,
    SafePipe,
    UserGuideComponent,
    UserPendingInviteComponent,
    ConfirmDailogue,
    WeatherPopupComponent,
    PhoneInputComponent,
    NgFileUploadDirective,
    DebounceDirective,
    FileDragNDropDirective,
    AppDatePipe,
  ],
  imports: [
    NgbModule,
    CommonModule,
    NgbDropdownModule,
    NgOtpInputModule,
    ToastrModule.forRoot({ timeOut: 7000 }),
    NgxDocViewerModule,
    PdfViewerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
  ],
  exports: [
    PhoneInputComponent,
    NgbModule,
    CommonModule,
    NgbDropdownModule,
    ToastrModule,
    VaultAuthenticationComponent,
    DisableButtonDuringAjax,
    SanitizeHtmlPipe,
    SearchPipe,
    SafePipe,
    NgxDocViewerModule,
    PdfViewerModule,
    UserGuideComponent,
    UserPendingInviteComponent,
    FormsModule,
    ReactiveFormsModule,
    NgFileUploadDirective,
    DebounceDirective,
    FileDragNDropDirective,
    AppDatePipe,
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class SharedModule { }
